module.exports = __webpack_public_path__ + "img/SKMJ_standard7.4265d5f3.png";